import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API, useAuth } from "@/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const sid = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, {}, {
          headers: { "X-Session-ID": sid },
          withCredentials: true,
        });
        setUser(data.user);
        // Also store token for Bearer-based fallback (cross-domain preview)
        if (data.session_token) localStorage.setItem("token", data.session_token);
        window.history.replaceState({}, "", "/dashboard");
        toast.success(`Xoş gəlmisiniz, ${data.user.first_name}!`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google girişi uğursuz oldu");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <Loader2 className="h-10 w-10 text-blue-600 animate-spin" />
      <p className="text-slate-600 font-semibold">Google girişi işlənilir...</p>
    </div>
  );
}
